import { Xmark } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const CrossIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Xmark width={size} height={size} color={color} {...rest} />;

CrossIcon.displayName = 'CrossIcon';
export default CrossIcon;
